module.exports = __webpack_public_path__ + "img/FGr_Ölschaden_A.88dc526a.svg";